
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { useState, useRef, useEffect } from 'react'
import { DisplayTestEditMode } from "../aitest/DisplayTestEditMode"
import Stack from '@mui/material/Stack'
import { PushButton } from '../pushbutton/PushButton'
import { AlertDialog } from '../alertdialog/AlertDialog'
import { DialogModifyTest } from './DialogModifyTest';
import {CustomTooltip} from  '../customtooltip/CustomTooltip'
import ResetIcon from '../customicons/ResetIcon'
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import Checkbox from '@mui/material/Checkbox';

import "./aitest.css"

export const Questions = ({ correctanswersonly }) => {

  const [openDialogBoxReset, handleResetDlg] = useState(false);
  const [dialogtext, setDialogText] = useState('');

  let {
    isMe,
    isMobile,
    isLoading,
    changeLanguage,
    changeTestLanguage,
  
  } = React.useContext(StatusContext);

  let {
    promptsandresponses,
    onDeletePrompt,
    onCancelDelete,
    onAcceptDelete,
    onChange,
    onSubmitAnswer,
    onAcceptAnswer,
    onResetAnswer,
    onMoveUp,
    onMoveDown,
    testpreview,
    onResetTest,
    onMoreAnswer,
    onMoreQuestion,
    onEditTest,
    onSaveTest,
    createtestmode,
   
    testScore,
    previewMessage,
    status,

    setShowCorrectAnswersOnly,
    showcorrectanswersonly,

    setShowQuestionsOnly,
    showquestionsonly,

    setPromptsAndResponses,

  } = React.useContext(AITestContext);

  const promptAreaRef = useRef(null);

  const onShowAnswersOnly = () => {

    let b = !showcorrectanswersonly
  
     let a = [...promptsandresponses]

        a.forEach((item)=> 
        {
            item.response.answer[0][1] = b
            item.response.answer[0][2] = b
            item.response.answer[1][1] = b
            item.response.answer[1][2] = b
            item.response.answer[2][1] = b
            item.response.answer[2][2] = b
        })
       
        setPromptsAndResponses(a)
        setShowCorrectAnswersOnly(b)
      
  }
  
  const onShowQuestionsOnly = () => {
    console.log("onShowQuestionsOnly")
    setShowQuestionsOnly(!showquestionsonly)
  }

  const openDialogReset = () => {
    handleResetDlg(true);
  };
  const closeDialogReset = () => {
    handleResetDlg(false);
  };

  const alertYesReset = () => {
    console.log("AlertYesReset")
    closeDialogReset()
    onResetTest()
  }

  const alertCancelReset = () => {
    console.log("AlertCancelReset")
    closeDialogReset()
  }

  const handleClickReset = () => {
    setDialogText(changeTestLanguage('aitest', 'resetanswers'))
    openDialogReset()
  }


  useEffect(() => {
    console.log("Question: useEffect")

    if (promptAreaRef.current) {
      promptAreaRef.current.style.height = 'auto';
      promptAreaRef.current.style.height = `${promptAreaRef.current.scrollHeight}px`;
    }
  }, [promptAreaRef]);

  return (

    <div style={{ width: "100%", paddingLeft:isMobile() ? '0%' : '10%',   paddingRight: isMobile() ? '0%' : '10%'}}>
      {
        <>
        <br/>
          <div className = 'flex-container' style={{marginTop: '-10px'}}>
           
            <Checkbox className='checkBoxTestName' onClick = {onShowAnswersOnly}
                checked={showcorrectanswersonly}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'},       
            }} />          
            <label style={{paddingRight:'5px'}}> {changeTestLanguage('aitest', 'showanswersonly')} </label>
          </div>
          
          {
            isMe() &&
           <div className = 'flex-container' style={{marginTop: '-10px'}}>
            <Checkbox className='checkBoxTestName' onClick = {onShowQuestionsOnly}
                checked={showquestionsonly}
                sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'},       
            }} />          
            <label style={{paddingRight:'5px'}}> {changeTestLanguage('aitest', 'showquestionsonly')} </label>
          </div>
          }

          {

          promptsandresponses.length > 0 &&
          <div className="mainButtons">
            <label style={{ fontSize: '16px', fontWeight: 'bold' }}>{changeTestLanguage("aitest", 'tests')} :   <span style={{ color: 'maroon' }}>
              {testScore} / {promptsandresponses.length}
            </span></label>
            <Stack direction="row" spacing={2}>
              {
                <>
                      <CustomTooltip title={changeTestLanguage('aitest', 'resettooltip')}>
                        <span>
                          <ResetIcon onClick={() => { !isLoading && handleClickReset() }} />
                        </span>
                      </CustomTooltip>
                  {
                    (createtestmode) &&
                    <>
                    <PushButton onClick={onSaveTest} label={changeLanguage('aitest', 'saveanswers')} disablebutton={promptsandresponses.length > 0 ? false : true} />
                    </>
                  }
                  
                  {/*
                    (selecttestmode || collegetestmode) &&
                    <PushButton onClick={onSaveChosenTest_prompt} label={changeLanguage('aitest', 'saveanswers')} disablebutton={(testpreview || promptsandresponses.length === 0) ? true : false} />
                  */}


                </>
              }
            </Stack>
          </div>
          }
          {
            (testpreview) &&
            <>
              <label style={{ color: 'red', fontSize: '20px', }}>{previewMessage}</label>
              <br></br>
              <br></br>
            </>
          }
          <div className="questionsarea">
              {
                Array.isArray(promptsandresponses) &&
                promptsandresponses.map((item, idx) => (
                 
                    <DisplayTestEditMode key={item.id} displayprompt={item} disableMoveUp={idx === 0}
                      disableMoveDown={idx === (promptsandresponses.length - 1)}
                      onCancelDelete={onCancelDelete}
                      onAcceptDelete={onAcceptDelete}
                      onDeletePrompt={onDeletePrompt}
                      onSubmitAnswer={onSubmitAnswer}
                      onAcceptAnswer={onAcceptAnswer}
                      onResetAnswer={onResetAnswer}
                      onChange={onChange}
                      onMoveUp={onMoveUp}
                      onMoveDown={onMoveDown}
                      seqid={idx + 1}
                      total={promptsandresponses.length}
                      onMoreAnswer={onMoreAnswer}
                      onMoreQuestion={onMoreQuestion}
                      onEditTest={onEditTest}
                    
                    />
                    
                ))
              }
         
          </div>

          <div className="mainButtons">
            {
              createtestmode ?
                null
                :
                <div style={{ width: '60%' }}>
                  <label> </label>
                </div>

            }

              {
                  (!status) &&
                      <WaitonResponse />
              }

         
          </div>
        </>

      }
      <AlertDialog alertYes={alertYesReset} alertCancel={alertCancelReset} openDialog={openDialogBoxReset} closeDialog={closeDialogReset} prompt={dialogtext} />
      {/*<DialogMoreAnswer />*/}
      <DialogModifyTest />

    </div>

  )

}

Questions.defaultProps = {
  correctanswersonly: false,
};




